/**
 * Creates and caches a WebGPU node material for a source {@link MatcapShaderMaterial}.
 */
import { GenesysMatcapNodeMaterial } from './GenesysMatcapNodeMaterial.js';

import type { MatcapShaderMaterial } from './MatcapShaderMaterial.js';

const webGpuMatcapBySource = new WeakMap<MatcapShaderMaterial, GenesysMatcapNodeMaterial>();

export function getOrCreateWebGpuMatcapFromSource(source: MatcapShaderMaterial): GenesysMatcapNodeMaterial {
  let derived = webGpuMatcapBySource.get(source);
  if (!derived) {
    derived = new GenesysMatcapNodeMaterial(source);
    derived.name = `${source.name}(WebGPU)`;
    webGpuMatcapBySource.set(source, derived);
  }
  return derived;
}
